module.exports = __webpack_public_path__ + "static/media/attachment-icon-blue.ff84a50c.svg";